import React from 'react';
import Dialog from 'components/Dialog';
import {Grid} from '@mui/material';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import * as yup from 'common/yup';
import Formik, {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import {useTranslation} from 'react-i18next';
import FormikSwitch from 'components/inputs/FormikSwitch';
import {useFieldValue} from 'components/hook-form/useFieldValue';
import {IDiplomatObject} from 'types/DiplomatObject';
import FormikTransferListSearchable from 'components/inputs/FormikTransferListSearchable';

// const validationSchema = yup.object({
//    [SFTPFilesystemNames.user]: yup.string(),
//    [SFTPFilesystemNames.group]: yup.string(),
//    [SFTPFilesystemNames.inherit]: yup.string(),
//    _switch: yup.bool(),
// });

// // .test('user/group', 'User or group are required', );
// export type SwitchTransferListDialogFormType = yup.InferType<typeof validationSchema>;

// const validate = (values: SwitchTransferListDialogFormType) => {
//    if (!values.user && !values.group) {
//       return {
//          [SFTPFilesystemNames.user]: 'User or group are required',
//          [SFTPFilesystemNames.group]: 'User or group are required',
//       };
//    }
//    return true;
// };

type SwitchTransferListFormProps = {
   names: [string, string];
   onClose: () => void;
   group1: IDiplomatObject[];
   group2: IDiplomatObject[];
   labels: [string, string];
};

const SwitchTransferListForm = ({
   onClose,
   group1,
   group2,
   labels,
   names,
}: SwitchTransferListFormProps) => {
   const {t} = useTranslation();
   const isGroup = useFieldValue('_switch');
   //    console.debug('isGroup', isGroup);
   return (
      <>
         <Grid container spacing={3} justifyContent="center">
            <Grid item sm={11}>
               <FormikSwitch silent name="_switch" labels={labels} />
               {isGroup ? (
                  <FormikTransferListSearchable
                     key={names[1]}
                     name={names[1]}
                     optionsLabel={t('Not Assigned')}
                     valuesLabel={t('Assigned')}
                     options={group2}
                  />
               ) : (
                  <FormikTransferListSearchable
                     key={names[0]}
                     name={names[0]}
                     optionsLabel={t('Not Assigned')}
                     valuesLabel={t('Assigned')}
                     options={group1}
                  />
               )}
               {/* <FormikTextField
         name={SFTPFilesystemNames.inherit}
         label={t('Inherited from')}
      /> */}
            </Grid>
         </Grid>
         <Grid container spacing={3} justifyContent="center">
            <Grid item>
               <FormFooterButtons cancel={onClose} />
            </Grid>
         </Grid>
      </>
   );
};

export interface SwitchTransferListDialogDialogProps<T, K extends object> {
   open?: boolean;
   values?: [string[], string[]];
   title: string;

   options: [T[], T[]];
   labels: [string, string];
   names: SwitchTransferListFormProps['names'];
   validationSchema: yup.ObjectSchema<K>;
   validate?: (values: K) => K;
}

interface Props<T, K extends object> {
   data: SwitchTransferListDialogDialogProps<T, K>;
   onClose: (nameObj?: K, callbacks?: FormOnSubmitHelpers<K>) => void;
}
export const SwitchTransferListDialog = React.memo(
   ({
      onClose: onSubmit,
      data: {
         values = [[], []] as [string[], string[]],
         open = true,
         options,
         validationSchema,
         validate,
         labels,
         title,
         names,
      },
   }: Props<IDiplomatObject, any>) => {
      const {t} = useTranslation();
      const onClose = React.useCallback(() => onSubmit(), [onSubmit]);

      //   console.debug('groups', group1, group2);

      return (
         <Dialog open={open} maxWidth="md" header={title} close={onClose}>
            <Formik
               initialValues={validationSchema?.cast({
                  [names[0]]: values[0],
                  [names[1]]: values[1],
                  _switch: true,
               })}
               // initialTouched={Boolean(value) ? ['name'] : undefined}
               validationSchema={validationSchema}
               onSubmit={onSubmit}
               validate={validate}
               enableReinitialize
            >
               <SwitchTransferListForm
                  onClose={onClose}
                  group1={options[0]}
                  group2={options[1]}
                  labels={labels}
                  names={names}
               />
            </Formik>
         </Dialog>
      );
   }
);
